// import { useCallback, useEffect, useRef, useState } from "react";
// import styles from "../../../pages/ordermanager/Orders.module.css";
// import { CrossIcon, CrossIcon2, SkipIcon, TickIcon } from "../../icons/Icon";
// import Button from "../Dealers/Button";
// import InputTag from "../FormComponents/InputTag";
// import SlidingFilter2 from "../Dealers/SlidingFilter2";
// import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";
// import fetchData from "../../../APIsControll/apiControll";
// import { useToast } from "../Toaster/Toaster";
// import { useDispatch, useSelector } from "react-redux";
// import { setFilter } from "../../../store/slices/order/OrderSlice";

// const ProSaleShippingChargesModal = ({
//   mode,
//   orderId,
//   close,
//   skipShippingCharges,
//   itemsdetails,
//   isShippingBlocked,
//   shippingType = "",
//   pincode,
//   shippingInfo,
//   setShippingInfo,
//   openShippingChargesInfoModal,
//   warehouse,
//   setGeneralInfo,
//   type2,
//   setDispatchWarehouse,
//   selectDispatchWarehouse,
// }) => {
//   const elementsRef = useRef([]);
//   const { show } = useToast();
//   const { filter } = useSelector((r) => r.order);
//   const dispatch = useDispatch();

//   const uniqueWarehouses = itemsdetails
//     .filter((item) => item.warehouse && item.warehouse.trim() !== "")
//     .reduce((acc, item) => {
//       const existing = acc.find(
//         (w) =>
//           w.warehouse === item.warehouse && w.warehouseId === item.warehouseId,
//       );
//       if (!existing) {
//         acc.push({
//           warehouse: item.warehouse,
//           warehouseId: item.warehouseId,
//         });
//       }
//       return acc;
//     }, []);

//   const [selectedWarehouse, setSelectedWarehouse] = useState(() => {
//     const first = uniqueWarehouses?.[0];
//     return first
//       ? {
//           label: first.warehouse,
//           value: first.warehouseId,
//         }
//       : { label: "", value: "" };
//   });

//   const [dw, setDw] = useState({ label: "Select", value: "Select" });

//   const [focusedIndex, setFocusedIndex] = useState(0);

//   const [partners, setPartners] = useState([]);
//   const [courierName, setCourierName] = useState("");

//   const handleSeparatePartnersSelection = (d) => {
//     const { methodId, methodName } = d;
//     const isSelf = methodName === "Self";

//     const newEntry = {
//       methodId,
//       shippingCharge: 0,
//       courierName: isSelf ? "Pick Up" : courierName,
//       methodName: isSelf ? "Self" : methodName,
//       partnerName: isSelf ? "Self" : methodName,
//       warehousename: selectedWarehouse.label,
//       warehouseId: selectedWarehouse.value,
//       isDispatchWarehouse: true,
//       delInstruction: "",
//     };

//     setShippingInfo((prev) => {
//       const existingIndex = prev.findIndex(
//         (item) => item.warehouseId === selectedWarehouse.value,
//       );

//       let updatedShippingInfo = [...prev];

//       if (existingIndex !== -1) {
//         updatedShippingInfo[existingIndex] = newEntry;
//       } else {
//         updatedShippingInfo.push(newEntry);
//       }

//       const currentIndex = uniqueWarehouses.findIndex(
//         (w) => w.warehouseId === selectedWarehouse.value,
//       );

//       // ── Open the shipping-charges-info modal once every warehouse has
//       //    a method assigned (i.e. this was the last one) ─────────────
//       if (currentIndex === uniqueWarehouses.length - 1) {
//         setTimeout(() => {
//           openShippingChargesInfoModal(
//             shippingType,
//             selectedWarehouse,
//             updatedShippingInfo,
//             uniqueWarehouses,
//           );
//         }, 0);
//       }

//       return updatedShippingInfo;
//     });

//     setGeneralInfo((prev) => ({
//       ...prev,
//       deliveryPartners: prev.deliveryPartners
//         ? [
//             ...prev.deliveryPartners,
//             {
//               label: isSelf ? "Self" : methodName,
//               value: isSelf ? "Self" : methodName,
//             },
//           ]
//         : [
//             {
//               label: isSelf ? "Self" : methodName,
//               value: isSelf ? "Self" : methodName,
//             },
//           ],
//     }));

//     const currentIndex = uniqueWarehouses.findIndex(
//       (w) => w.warehouseId === selectedWarehouse.value,
//     );

//     if (currentIndex < uniqueWarehouses.length - 1) {
//       const nextWarehouse = uniqueWarehouses[currentIndex + 1];
//       setSelectedWarehouse({
//         label: nextWarehouse.warehouse,
//         value: nextWarehouse.warehouseId,
//       });
//     }
//   };

//   /* ------------------------------------------------------------------ *
//    *  COMBINED shipping type: one method applies to every warehouse.
//    *  Fix: openShippingChargesInfoModal(...) is now called WITH the real
//    *  shippingType/dw/updatedShippingInfo/uniqueWarehouses instead of no
//    *  arguments — that was why the info modal opened with broken/blank
//    *  values right after picking a method.
//    * ------------------------------------------------------------------ */
//   const handleCombinedPartnerSelect = (d) => {
//     const { methodId, methodName } = d;

//     if (methodName === "Self") {
//       handleSkip();
//     } else {
//       setShippingInfo((prev) => {
//         const newEntries = uniqueWarehouses.map((w) => {
//           return {
//             methodId,
//             shippingCharge: 0,
//             courierName,
//             methodName,
//             partnerName: methodName,
//             warehousename: w.warehouse,
//             warehouseId: w.warehouseId,
//             isDispatchWarehouse: w.warehouseId === dw.value,
//             delInstruction: "",
//           };
//         });

//         const updatedShippingInfo = prev.filter(
//           (item) =>
//             !uniqueWarehouses.some((w) => w.warehouseId === item.warehouseId),
//         );

//         updatedShippingInfo.push(...newEntries);

//         setTimeout(() => {
//           openShippingChargesInfoModal(
//             shippingType,
//             dw,
//             updatedShippingInfo,
//             uniqueWarehouses,
//           );
//         }, 0);

//         return updatedShippingInfo;
//       });

//       setGeneralInfo((prev) => ({
//         ...prev,
//         deliveryPartners: prev.deliveryPartners
//           ? [...prev.deliveryPartners, { label: methodName, value: methodName }]
//           : [{ label: methodName, value: methodName }],
//       }));

//       if (uniqueWarehouses.length > 0) {
//         setSelectedWarehouse({
//           label: uniqueWarehouses[0].warehouse,
//           value: uniqueWarehouses[0].warehouseId,
//         });
//       }
//     }
//   };

//   const selectMethod = (p) => {
//     if (shippingType === "Combined") {
//       handleCombinedPartnerSelect(p);
//     } else {
//       handleSeparatePartnersSelection(p);
//     }
//   };

//   const getDeliveryMethods = useCallback(async () => {
//     try {
//       const result = await fetchData("deliverymethod/deliveryMethods", {
//         shipPincode: parseInt(pincode),
//       });
//       if (result.status === "success") {
//         if (result.methodSelection === "Active") {
//           setPartners(result.deliveryMethod);
//           setCourierName(result.courierName);
//           dispatch(setFilter({ selectedOption: "no" }));
//           setGeneralInfo((prev) => ({
//             ...prev,
//             courierName: result.courierName,
//           }));
//         }
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   }, [dispatch, pincode, setGeneralInfo]);

//   const handleNo = useCallback(() => {
//     if (shippingType === "Combined") {
//       if (dw.label === "Select") {
//         show("Select dispatch ware house first!", "error");
//       } else {
//         dispatch(setFilter({ selectedOption: "yes" }));
//         getDeliveryMethods();
//       }
//     } else {
//       dispatch(setFilter({ selectedOption: "yes" }));
//       getDeliveryMethods();
//     }
//   }, [shippingType, dw.label, show, dispatch, getDeliveryMethods]);

//   const handleSkip = useCallback(() => {
//     if (shippingType === "Combined") {
//       if (dw.label === "Select") {
//         show("Select dispatch ware house first!", "error");
//       } else {
//         dispatch(setFilter({ selectedOption: "skip" }));
//         skipShippingCharges && skipShippingCharges(dw);
//         close();
//       }
//     } else {
//       dispatch(setFilter({ selectedOption: "skip" }));
//       skipShippingCharges && skipShippingCharges(dw);
//       close();
//     }
//   }, [shippingType, dw, show, dispatch, skipShippingCharges, close]);

//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setFocusedIndex((prev) =>
//         prev === elementsRef.current.length - 1 ? 0 : prev + 1,
//       );
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setFocusedIndex((prev) =>
//         prev === 0 ? elementsRef.current.length - 1 : prev - 1,
//       );
//     }
//   };

//   useEffect(() => {
//     if (!orderId) {
//       dispatch(setFilter({ selectedOption: "" }));
//     }
//   }, [dispatch, orderId]);

//   useEffect(() => {
//     const handleKeyPress = (e) => {
//       if (filter.selectedOption !== "no") {
//         if (e.key.toLowerCase() === "y" && !isShippingBlocked) {
//           handleNo();
//         }
//         if (e.key.toLowerCase() === "n" && !isShippingBlocked) {
//           handleNo();
//         }
//         if (e.key.toLowerCase() === "s") {
//           handleSkip();
//         }
//       }
//     };
//     window.addEventListener("keydown", handleKeyPress);
//     return () => {
//       window.removeEventListener("keydown", handleKeyPress);
//     };
//   }, [
//     filter.selectedOption,
//     handleNo,
//     handleSkip,
//     isShippingBlocked,
//     shippingType,
//   ]);

//   useEffect(() => {
//     if (filter.selectedOption === "no") {
//       if (elementsRef.current[0]) {
//         elementsRef.current[0].focus();
//       }
//     }
//   }, [filter.selectedOption]);

//   useEffect(() => {
//     if (elementsRef.current[focusedIndex]) {
//       elementsRef.current[focusedIndex].focus();
//     }
//   }, [focusedIndex]);

//   const updatedPartners = [
//     {
//       methodId: "0",
//       methodName: "Self",
//       methodStatus: "Active",
//       maxVm: "No Limit",
//       maxWeight: "No Limit",
//       maxLimit: "No Limit",
//       maxLimitStatus: "Active",
//     },
//     ...partners,
//   ];

//   // ── FIX: was comparing against selectedWarehouse.warehouseId, which
//   //    doesn't exist on the {label, value} shape — totals for "Separate"
//   //    always came out empty/0. Compare against .value instead. ─────────
//   const filteredItems =
//     shippingType === "Separate"
//       ? itemsdetails.filter(
//           (item) => item.warehouseId === selectedWarehouse.value,
//         )
//       : itemsdetails;

//   const totalCBM = parseFloat(
//     filteredItems
//       .reduce((sum, item) => sum + (Number(item.vm) * item.qty || 0), 0)
//       .toFixed(5),
//   );

//   const totalWeight = parseFloat(
//     filteredItems
//       .reduce((sum, item) => sum + (Number(item.weight) * item.qty || 0), 0)
//       .toFixed(5),
//   );

//   const groupItems = (items) => {
//     const validItems = items.filter((item) => item.itemNo && item.qty);

//     const grouped = {};

//     validItems.forEach((item) => {
//       const {
//         itemNo,
//         warehouse = "",
//         warehouseId = "",
//         weight,
//         vm,
//         qty,
//       } = item;

//       const key = `${itemNo}-${warehouse}-${warehouseId}-${weight ?? "NA"}-${vm ?? "NA"}`;

//       if (!grouped[key]) {
//         grouped[key] = {
//           itemNo,
//           warehouse,
//           warehouseId,
//           weight: weight ?? null,
//           vm: vm ?? null,
//           qty: Number(qty) || 0,
//         };
//       } else {
//         grouped[key].qty += Number(qty) || 0;
//       }
//     });

//     return Object.values(grouped);
//   };

//   const warehouseDisplayList = uniqueWarehouses.map((w) => ({
//     id: w.warehouseId,
//     label: w.warehouse,
//   }));

//   const warehouseChange = (warehouseId) => {
//     const selectedWarehouseObj = uniqueWarehouses.find(
//       (item) => item.warehouseId === warehouseId,
//     );

//     if (selectedWarehouseObj) {
//       setSelectedWarehouse({
//         label: selectedWarehouseObj.warehouse,
//         value: selectedWarehouseObj.warehouseId,
//       });
//     }
//   };

//   const groupedItems = groupItems(itemsdetails);

//   useEffect(() => {
//     setDispatchWarehouse(selectedWarehouse);
//     setDw(selectedWarehouse);
//   }, [
//     selectedWarehouse,
//     setDispatchWarehouse,
//     shippingInfo,
//     shippingType,
//     type2,
//     warehouse,
//   ]);

//   const getMaxColor = (totalValue, value) => {
//     if (value === "No Limit") {
//       return "#31974D";
//     }

//     if (value >= totalValue) {
//       return "#31974D";
//     } else {
//       return "#F93E3E";
//     }
//   };

//   const liStyles = {
//     backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
//     color: mode ? "#FFFFFF" : "#646B88",
//     fontWeight: "600",
//   };

//   const dataListLiStyles = {
//     backgroundColor: mode ? "#2C2E33" : "",
//     color: mode ? "#FFFFFF" : "#646B88",
//     fontWeight: "600",
//   };

//   const IPSLiStyles = {
//     backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
//   };

//   return (
//     <div
//       className={`${styles.shipping_charges_modal} ${
//         mode ? styles.shipping_charges_modal_dark : {}
//       }`}
//     >
//       {shippingType === "Separate" && (
//         <SlidingFilter2
//           itemList={warehouseDisplayList.map((w) => w.label)}
//           selectedItem={selectedWarehouse.label}
//           setFilter={(label) => {
//             const found = warehouseDisplayList.find((w) => w.label === label);
//             if (found) {
//               warehouseChange(found.id);
//             }
//           }}
//           enableKeyboardNavigation
//         />
//       )}
//       <div className={`${styles.scm_con}`}>
//         <div className={styles.item_properties} style={{}}>
//           <div className={styles.header_con}>
//             <p className={styles.header}>Packaging Info</p>
//             {(shippingType === "Combined" || type2 === "normal") && (
//               <div>
//                 <VerticalDropDown2
//                   disableOpen
//                   height={"37px"}
//                   fontSize={"12px"}
//                   label={"Warehouse"}
//                   dropDownText={"Warehouse"}
//                   value={dw}
//                   onchange={(value) => {
//                     setDw(value);
//                     setDispatchWarehouse(value);
//                     selectDispatchWarehouse(value);
//                   }}
//                   options={uniqueWarehouses.map((w) => ({
//                     label: w.warehouse,
//                     value: w.warehouseId,
//                   }))}
//                   dropDownOpen={type2 !== "normal" ? true : false}
//                 />
//               </div>
//             )}
//           </div>
//           <ul className={styles.data_list}>
//             <li style={dataListLiStyles}>
//               <div>Item</div>
//               <div>Warehouse</div>
//               <div>Quantity</div>
//               <div>Volume(CBM)</div>
//               <div>Weight(KG)</div>
//             </li>
//             <div className={styles.item_properties_scroll}>
//               {groupedItems
//                 .filter((item) =>
//                   shippingType === "Separate"
//                     ? item.warehouseId === selectedWarehouse.value
//                     : true,
//                 )
//                 .sort((a, b) => {
//                   if (shippingType !== "Separate") {
//                     return a.warehouseId.localeCompare(b.warehouseId);
//                   }
//                   return 0;
//                 })
//                 .map(({ itemNo, warehouse, weight, vm, qty }, index) => (
//                   <li style={IPSLiStyles} key={index}>
//                     <div title={itemNo}>{itemNo}</div>
//                     <div title={warehouse}>{warehouse}</div>
//                     <div title={qty}>{qty}</div>
//                     <div
//                       title={`${qty} x ${vm || 0}`}
//                     >{`${qty} x ${vm || 0}`}</div>
//                     <div
//                       title={`${qty} x ${weight || 0}`}
//                     >{`${qty} x ${weight || 0}`}</div>
//                   </li>
//                 ))}
//             </div>
//             <div style={{ flex: "1" }}></div>
//             <li style={liStyles}>
//               <div>Total</div>
//               <div></div>
//               <div></div>
//               <div>{totalCBM}</div>
//               <div>{totalWeight}</div>
//             </li>
//           </ul>
//         </div>

//         {filter.selectedOption !== "no" && (
//           <div className={`${styles.shipping_charges_mid}`}>
//             <img
//               src="/assets/updatedAssets/shippingCharge.png"
//               alt="Shipping charges"
//             />
//             <p>
//               Do you want the system to calculate shipping charges
//               automatically?
//             </p>

//             <div>
//               {!isShippingBlocked && (
//                 <div>
//                   <Button
//                     buttonText={"YES"}
//                     buttonIcon={<TickIcon />}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={handleNo}
//                   />
//                   <p className={styles.btn_text}>Press - Y</p>
//                 </div>
//               )}

//               {!isShippingBlocked && (
//                 <div>
//                   <Button
//                     buttonText={"NO"}
//                     buttonIcon={<CrossIcon2 />}
//                     buttonBgColor={"#F93E3E"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={handleNo}
//                   />
//                   <p className={styles.btn_text}>Press - N</p>
//                 </div>
//               )}

//               <div>
//                 <Button
//                   buttonText={"SKIP"}
//                   buttonIcon={<SkipIcon />}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#FFFFFF"}
//                   buttonBorder={"none"}
//                   buttonClick={handleSkip}
//                 />
//                 <p className={styles.btn_text}>Press - S</p>
//               </div>
//             </div>
//           </div>
//         )}

//         {filter.selectedOption === "no" && (
//           <div className={styles.flex_col}>
//             <div className={styles.flex}>
//               <p className={styles.header} style={{ width: "100%" }}>
//                 Delivery Method
//               </p>
//               <span onClick={close} style={{ cursor: "pointer" }}>
//                 <CrossIcon color={mode ? "#FFF" : "#000"} />
//               </span>
//             </div>

//             <InputTag
//               value={courierName}
//               readOnly={true}
//               maxLength={100}
//               padding={"8px"}
//               fontSize={"12px"}
//             />

//             <div className={styles.delivery_method} onKeyDown={handleKeyDown}>
//               {updatedPartners.map((p, index) => (
//                 <div
//                   className={styles.delivery_method_element}
//                   key={p.methodId}
//                 >
//                   <div
//                     className={`${styles.delivery_method_element_option} ${
//                       focusedIndex === index ? styles.focused : ""
//                     } ${mode ? styles.dark_Op : {}}`}
//                     tabIndex={0}
//                     ref={(el) => (elementsRef.current[index] = el)}
//                     onClick={() => {
//                       selectMethod(p);
//                     }}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         selectMethod(p);
//                       }
//                     }}
//                   >
//                     {p.methodName}
//                   </div>
//                   <div className={styles.flex} style={{ gap: "10px" }}>
//                     <span>
//                       Max Weight :
//                       <span
//                         style={{ color: getMaxColor(totalWeight, p.maxWeight) }}
//                       >
//                         {p.maxWeight}
//                       </span>
//                     </span>
//                     <span>
//                       Max Volume :
//                       <span style={{ color: getMaxColor(totalCBM, p.maxVm) }}>
//                         {p.maxVm}
//                       </span>
//                     </span>
//                     <span>Max Limit : {p.maxLimit}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProSaleShippingChargesModal;

// import { useCallback, useEffect, useRef, useState } from "react";
// import styles from "../../../pages/ordermanager/Orders.module.css";
// import { CrossIcon, CrossIcon2, SkipIcon, TickIcon } from "../../icons/Icon";
// import Button from "../Dealers/Button";
// import InputTag from "../FormComponents/InputTag";

// import fetchData from "../../../APIsControll/apiControll";
// import { useToast } from "../Toaster/Toaster";
// import { useDispatch, useSelector } from "react-redux";
// import { setFilter } from "../../../store/slices/order/OrderSlice";

// const ProSaleShippingChargesModal = ({
//   mode,
//   orderId,
//   close,
//   skipShippingCharges,
//   itemsdetails,
//   isShippingBlocked,
//   shippingType = "",
//   pincode,
//   shippingInfo,
//   setShippingInfo,
//   openShippingChargesInfoModal,
//   warehouse,
//   setGeneralInfo,
//   type2,
//   setDispatchWarehouse,
//   selectDispatchWarehouse,
// }) => {
//   const elementsRef = useRef([]);
//   const { show } = useToast();
//   const { filter } = useSelector((r) => r.order);
//   const dispatch = useDispatch();

//   const [focusedIndex, setFocusedIndex] = useState(0);

//   const [partners, setPartners] = useState([]);
//   const [courierName, setCourierName] = useState("");

//   // const handleSeparatePartnersSelection = (d) => {
//   //   const { methodId, methodName } = d;
//   //   const isSelf = methodName === "Self";

//   //   const newEntry = {
//   //     methodId,
//   //     shippingCharge: 0,
//   //     courierName: isSelf ? "Pick Up" : courierName,
//   //     methodName: isSelf ? "Self" : methodName,
//   //     partnerName: isSelf ? "Self" : methodName,
//   //     warehousename: selectedWarehouse.label,
//   //     warehouseId: selectedWarehouse.value,
//   //     isDispatchWarehouse: true,
//   //     delInstruction: "",
//   //   };

//   //   setShippingInfo((prev) => {
//   //     const existingIndex = prev.findIndex(
//   //       (item) => item.warehouseId === selectedWarehouse.value,
//   //     );

//   //     let updatedShippingInfo = [...prev];

//   //     if (existingIndex !== -1) {
//   //       updatedShippingInfo[existingIndex] = newEntry;
//   //     } else {
//   //       updatedShippingInfo.push(newEntry);
//   //     }

//   //     const currentIndex = uniqueWarehouses.findIndex(
//   //       (w) => w.warehouseId === selectedWarehouse.value,
//   //     );

//   //     // ── Open the shipping-charges-info modal once every warehouse has
//   //     //    a method assigned (i.e. this was the last one) ─────────────
//   //     if (currentIndex === uniqueWarehouses.length - 1) {
//   //       setTimeout(() => {
//   //         openShippingChargesInfoModal(
//   //           shippingType,
//   //           selectedWarehouse,
//   //           updatedShippingInfo,
//   //           uniqueWarehouses,
//   //         );
//   //       }, 0);
//   //     }

//   //     return updatedShippingInfo;
//   //   });

//   //   setGeneralInfo((prev) => ({
//   //     ...prev,
//   //     deliveryPartners: prev.deliveryPartners
//   //       ? [
//   //           ...prev.deliveryPartners,
//   //           {
//   //             label: isSelf ? "Self" : methodName,
//   //             value: isSelf ? "Self" : methodName,
//   //           },
//   //         ]
//   //       : [
//   //           {
//   //             label: isSelf ? "Self" : methodName,
//   //             value: isSelf ? "Self" : methodName,
//   //           },
//   //         ],
//   //   }));

//   //   const currentIndex = uniqueWarehouses.findIndex(
//   //     (w) => w.warehouseId === selectedWarehouse.value,
//   //   );

//   //   if (currentIndex < uniqueWarehouses.length - 1) {
//   //     const nextWarehouse = uniqueWarehouses[currentIndex + 1];
//   //     setSelectedWarehouse({
//   //       label: nextWarehouse.warehouse,
//   //       value: nextWarehouse.warehouseId,
//   //     });
//   //   }
//   // };

//   // /* ------------------------------------------------------------------ *
//   //  *  COMBINED shipping type: one method applies to every warehouse.
//   //  *  Fix: openShippingChargesInfoModal(...) is now called WITH the real
//   //  *  shippingType/dw/updatedShippingInfo/uniqueWarehouses instead of no
//   //  *  arguments — that was why the info modal opened with broken/blank
//   //  *  values right after picking a method.
//   //  * ------------------------------------------------------------------ */
//   // const handleCombinedPartnerSelect = (d) => {
//   //   const { methodId, methodName } = d;

//   //   if (methodName === "Self") {
//   //     handleSkip();
//   //   } else {
//   //     setShippingInfo((prev) => {
//   //       const newEntries = uniqueWarehouses.map((w) => {
//   //         return {
//   //           methodId,
//   //           shippingCharge: 0,
//   //           courierName,
//   //           methodName,
//   //           partnerName: methodName,
//   //           warehousename: w.warehouse,
//   //           warehouseId: w.warehouseId,
//   //           isDispatchWarehouse: w.warehouseId === dw.value,
//   //           delInstruction: "",
//   //         };
//   //       });

//   //       const updatedShippingInfo = prev.filter(
//   //         (item) =>
//   //           !uniqueWarehouses.some((w) => w.warehouseId === item.warehouseId),
//   //       );

//   //       updatedShippingInfo.push(...newEntries);

//   //       setTimeout(() => {
//   //         openShippingChargesInfoModal(
//   //           shippingType,
//   //           dw,
//   //           updatedShippingInfo,
//   //           uniqueWarehouses,
//   //         );
//   //       }, 0);

//   //       return updatedShippingInfo;
//   //     });

//   //     setGeneralInfo((prev) => ({
//   //       ...prev,
//   //       deliveryPartners: prev.deliveryPartners
//   //         ? [...prev.deliveryPartners, { label: methodName, value: methodName }]
//   //         : [{ label: methodName, value: methodName }],
//   //     }));

//   //     if (uniqueWarehouses.length > 0) {
//   //       setSelectedWarehouse({
//   //         label: uniqueWarehouses[0].warehouse,
//   //         value: uniqueWarehouses[0].warehouseId,
//   //       });
//   //     }
//   //   }
//   // };

//   const selectMethod = (p) => {
//     // if (shippingType === "Combined") {
//     //   handleCombinedPartnerSelect(p);
//     // } else {
//     //   handleSeparatePartnersSelection(p);
//     // }
//   };

//   const getDeliveryMethods = useCallback(async () => {
//     try {
//       const result = await fetchData("deliverymethod/deliveryMethods", {
//         shipPincode: parseInt(pincode),
//       });
//       if (result.status === "success") {
//         if (result.methodSelection === "Active") {
//           setPartners(result.deliveryMethod);
//           setCourierName(result.courierName);
//           dispatch(setFilter({ selectedOption: "no" }));
//           setGeneralInfo((prev) => ({
//             ...prev,
//             courierName: result.courierName,
//           }));
//         }
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   }, [dispatch, pincode, setGeneralInfo]);

//   const handleNo = () => {};

//   const handleSkip = () => {};

//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setFocusedIndex((prev) =>
//         prev === elementsRef.current.length - 1 ? 0 : prev + 1,
//       );
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setFocusedIndex((prev) =>
//         prev === 0 ? elementsRef.current.length - 1 : prev - 1,
//       );
//     }
//   };

//   useEffect(() => {
//     if (!orderId) {
//       dispatch(setFilter({ selectedOption: "" }));
//     }
//   }, [dispatch, orderId]);

//   useEffect(() => {
//     const handleKeyPress = (e) => {
//       if (filter.selectedOption !== "no") {
//         if (e.key.toLowerCase() === "y" && !isShippingBlocked) {
//           handleNo();
//         }
//         if (e.key.toLowerCase() === "n" && !isShippingBlocked) {
//           handleNo();
//         }
//         if (e.key.toLowerCase() === "s") {
//           handleSkip();
//         }
//       }
//     };
//     window.addEventListener("keydown", handleKeyPress);
//     return () => {
//       window.removeEventListener("keydown", handleKeyPress);
//     };
//   }, [
//     filter.selectedOption,
//     handleNo,
//     handleSkip,
//     isShippingBlocked,
//     shippingType,
//   ]);

//   useEffect(() => {
//     if (filter.selectedOption === "no") {
//       if (elementsRef.current[0]) {
//         elementsRef.current[0].focus();
//       }
//     }
//   }, [filter.selectedOption]);

//   useEffect(() => {
//     if (elementsRef.current[focusedIndex]) {
//       elementsRef.current[focusedIndex].focus();
//     }
//   }, [focusedIndex]);

//   const updatedPartners = [
//     {
//       methodId: "0",
//       methodName: "Self",
//       methodStatus: "Active",
//       maxVm: "No Limit",
//       maxWeight: "No Limit",
//       maxLimit: "No Limit",
//       maxLimitStatus: "Active",
//     },
//     ...partners,
//   ];

//   // ── FIX: was comparing against selectedWarehouse.warehouseId, which
//   //    doesn't exist on the {label, value} shape — totals for "Separate"
//   //    always came out empty/0. Compare against .value instead. ─────────

//   const totalCBM = parseFloat(
//     itemsdetails
//       .reduce((sum, item) => sum + (Number(item.vm) * item.qty || 0), 0)
//       .toFixed(5),
//   );

//   const totalWeight = parseFloat(
//     itemsdetails
//       .reduce((sum, item) => sum + (Number(item.weight) * item.qty || 0), 0)
//       .toFixed(5),
//   );

//   const groupItems = (items) => {
//     const validItems = items.filter((item) => item.itemNo && item.qty);

//     const grouped = {};

//     validItems.forEach((item) => {
//       const {
//         itemNo,
//         warehouse = "",
//         warehouseId = "",
//         weight,
//         vm,
//         qty,
//       } = item;

//       const key = `${itemNo}-${warehouse}-${warehouseId}-${weight ?? "NA"}-${vm ?? "NA"}`;

//       if (!grouped[key]) {
//         grouped[key] = {
//           itemNo,
//           warehouse,
//           warehouseId,
//           weight: weight ?? null,
//           vm: vm ?? null,
//           qty: Number(qty) || 0,
//         };
//       } else {
//         grouped[key].qty += Number(qty) || 0;
//       }
//     });

//     return Object.values(grouped);
//   };

//   const groupedItems = groupItems(itemsdetails);

//   const getMaxColor = (totalValue, value) => {
//     if (value === "No Limit") {
//       return "#31974D";
//     }

//     if (value >= totalValue) {
//       return "#31974D";
//     } else {
//       return "#F93E3E";
//     }
//   };

//   const liStyles = {
//     backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
//     color: mode ? "#FFFFFF" : "#646B88",
//     fontWeight: "600",
//   };

//   const dataListLiStyles = {
//     backgroundColor: mode ? "#2C2E33" : "",
//     color: mode ? "#FFFFFF" : "#646B88",
//     fontWeight: "600",
//   };

//   const IPSLiStyles = {
//     backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
//   };

//   return (
//     <div
//       className={`${styles.shipping_charges_modal} ${
//         mode ? styles.shipping_charges_modal_dark : {}
//       }`}
//     >
//       <div className={`${styles.scm_con}`}>
//         <div className={styles.item_properties} style={{}}>
//           <div className={styles.header_con}>
//             <p className={styles.header}>Packaging Info</p>
//           </div>
//           <ul className={styles.data_list}>
//             <li style={dataListLiStyles}>
//               <div>Item</div>
//               <div>Warehouse</div>
//               <div>Quantity</div>
//               <div>Volume(CBM)</div>
//               <div>Weight(KG)</div>
//             </li>
//             <div className={styles.item_properties_scroll}>
//               {itemsdetails.map(
//                 ({ itemNo, warehouse, weight, vm, qty }, index) => (
//                   <li style={IPSLiStyles} key={index}>
//                     <div title={itemNo}>{itemNo}</div>
//                     <div title={warehouse}>{warehouse}</div>
//                     <div title={qty}>{qty}</div>
//                     <div
//                       title={`${qty} x ${vm || 0}`}
//                     >{`${qty} x ${vm || 0}`}</div>
//                     <div
//                       title={`${qty} x ${weight || 0}`}
//                     >{`${qty} x ${weight || 0}`}</div>
//                   </li>
//                 ),
//               )}
//             </div>
//             <div style={{ flex: "1" }}></div>
//             <li style={liStyles}>
//               <div>Total</div>
//               <div></div>
//               <div></div>
//               <div>{totalCBM}</div>
//               <div>{totalWeight}</div>
//             </li>
//           </ul>
//         </div>

//         {filter.selectedOption !== "no" && (
//           <div className={`${styles.shipping_charges_mid}`}>
//             <img
//               src="/assets/updatedAssets/shippingCharge.png"
//               alt="Shipping charges"
//             />
//             <p>
//               Do you want the system to calculate shipping charges
//               automatically?
//             </p>

//             <div>
//               {!isShippingBlocked && (
//                 <div>
//                   <Button
//                     buttonText={"YES"}
//                     buttonIcon={<TickIcon />}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={handleNo}
//                   />
//                   <p className={styles.btn_text}>Press - Y</p>
//                 </div>
//               )}

//               {!isShippingBlocked && (
//                 <div>
//                   <Button
//                     buttonText={"NO"}
//                     buttonIcon={<CrossIcon2 />}
//                     buttonBgColor={"#F93E3E"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={handleNo}
//                   />
//                   <p className={styles.btn_text}>Press - N</p>
//                 </div>
//               )}

//               <div>
//                 <Button
//                   buttonText={"SKIP"}
//                   buttonIcon={<SkipIcon />}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#FFFFFF"}
//                   buttonBorder={"none"}
//                   buttonClick={handleSkip}
//                 />
//                 <p className={styles.btn_text}>Press - S</p>
//               </div>
//             </div>
//           </div>
//         )}

//         {filter.selectedOption === "no" && (
//           <div className={styles.flex_col}>
//             <div className={styles.flex}>
//               <p className={styles.header} style={{ width: "100%" }}>
//                 Delivery Method
//               </p>
//               <span onClick={close} style={{ cursor: "pointer" }}>
//                 <CrossIcon color={mode ? "#FFF" : "#000"} />
//               </span>
//             </div>

//             <InputTag
//               value={courierName}
//               readOnly={true}
//               maxLength={100}
//               padding={"8px"}
//               fontSize={"12px"}
//             />

//             <div className={styles.delivery_method} onKeyDown={handleKeyDown}>
//               {updatedPartners.map((p, index) => (
//                 <div
//                   className={styles.delivery_method_element}
//                   key={p.methodId}
//                 >
//                   <div
//                     className={`${styles.delivery_method_element_option} ${
//                       focusedIndex === index ? styles.focused : ""
//                     } ${mode ? styles.dark_Op : {}}`}
//                     tabIndex={0}
//                     ref={(el) => (elementsRef.current[index] = el)}
//                     onClick={() => {
//                       selectMethod(p);
//                     }}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         selectMethod(p);
//                       }
//                     }}
//                   >
//                     {p.methodName}
//                   </div>
//                   <div className={styles.flex} style={{ gap: "10px" }}>
//                     <span>
//                       Max Weight :
//                       <span
//                         style={{ color: getMaxColor(totalWeight, p.maxWeight) }}
//                       >
//                         {p.maxWeight}
//                       </span>
//                     </span>
//                     <span>
//                       Max Volume :
//                       <span style={{ color: getMaxColor(totalCBM, p.maxVm) }}>
//                         {p.maxVm}
//                       </span>
//                     </span>
//                     <span>Max Limit : {p.maxLimit}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProSaleShippingChargesModal;

import { useCallback, useEffect, useRef, useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CrossIcon, CrossIcon2, SkipIcon, TickIcon } from "../../icons/Icon";
import Button from "../Dealers/Button";
import InputTag from "../FormComponents/InputTag";
import fetchData from "../../../APIsControll/apiControll";
import { useToast } from "../Toaster/Toaster";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../../store/slices/order/OrderSlice";

const ProSaleShippingChargesModal = ({
  mode,
  orderId,
  close,
  skipShippingCharges,
  itemsdetails,
  isShippingBlocked,
  pincode,
  shippingInfo,
  setShippingInfo,
  openShippingChargesInfoModal,
  setGeneralInfo,
  type2,
  checkboxRef,
  generalInfo,
}) => {
  const elementsRef = useRef([]);
  const { show } = useToast();
  const { filter } = useSelector((r) => r.order);
  const dispatch = useDispatch();

  const [focusedIndex, setFocusedIndex] = useState(0);
  const [partners, setPartners] = useState([]);
  const [courierName, setCourierName] = useState("");

  useEffect(() => {
    if (!orderId) {
      dispatch(setFilter({ selectedOption: "" }));
    }
  }, [dispatch, orderId]);

  const selectMethod = (p) => {
    const { methodId, methodName } = p;
    const isSelf = methodName === "Self";

    const updated = {
      ...shippingInfo,
      methodId,
      shippingCharge: isSelf ? 0 : shippingInfo?.shippingCharge || 0,
      courierName: isSelf ? "Pick Up" : courierName,
      methodName: isSelf ? "Self" : methodName,
      partnerName: isSelf ? "Self" : methodName,
      delInstruction: shippingInfo?.delInstruction || "",
    };

    setShippingInfo(updated);

    setGeneralInfo((prev) => ({
      ...prev,
      courierName: updated.courierName,
      deliveryPartners: {
        label: updated.methodName,
        value: updated.methodName,
      },
    }));

    if (isSelf) {
      close();
      requestAnimationFrame(() => checkboxRef?.current?.focus());
      return;
    }

    setTimeout(() => {
      openShippingChargesInfoModal(updated);
    }, 0);
  };

  const getDeliveryMethods = useCallback(async () => {
    try {
      const result = await fetchData("deliverymethod/deliveryMethods", {
        shipPincode: parseInt(pincode),
      });
      if (result.status === "success") {
        if (result.methodSelection === "Active") {
          setPartners(result.deliveryMethod);
          setCourierName(result.courierName);
          dispatch(setFilter({ selectedOption: "no" }));
          setGeneralInfo((prev) => ({
            ...prev,
            courierName: result.courierName,
          }));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [dispatch, pincode, setGeneralInfo]);

  const handleNo = useCallback(() => {
    dispatch(setFilter({ selectedOption: "yes" }));
    getDeliveryMethods();
  }, [dispatch, getDeliveryMethods]);

  const handleSkip = useCallback(() => {
    dispatch(setFilter({ selectedOption: "skip" }));
    skipShippingCharges && skipShippingCharges();
    close();
  }, [dispatch, skipShippingCharges, close]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setFocusedIndex((prev) =>
        prev === elementsRef.current.length - 1 ? 0 : prev + 1,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setFocusedIndex((prev) =>
        prev === 0 ? elementsRef.current.length - 1 : prev - 1,
      );
    }
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (filter.selectedOption !== "no") {
        if (e.key.toLowerCase() === "y" && !isShippingBlocked) handleNo();
        if (e.key.toLowerCase() === "n" && !isShippingBlocked) handleNo();
        if (e.key.toLowerCase() === "s") handleSkip();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [filter.selectedOption, handleNo, handleSkip, isShippingBlocked]);

  useEffect(() => {
    if (filter.selectedOption === "no" && elementsRef.current[0]) {
      elementsRef.current[0].focus();
    }
  }, [filter.selectedOption]);

  useEffect(() => {
    if (elementsRef.current[focusedIndex]) {
      elementsRef.current[focusedIndex].focus();
    }
  }, [focusedIndex]);

  const updatedPartners = [
    {
      methodId: "0",
      methodName: "Self",
      methodStatus: "Active",
      maxVm: "No Limit",
      maxWeight: "No Limit",
      maxLimit: "No Limit",
      maxLimitStatus: "Active",
    },
    ...partners,
  ];

  const totalCBM = parseFloat(
    itemsdetails
      .reduce((sum, item) => sum + (Number(item.vm) * item.qty || 0), 0)
      .toFixed(5),
  );

  const totalWeight = parseFloat(
    itemsdetails
      .reduce((sum, item) => sum + (Number(item.weight) * item.qty || 0), 0)
      .toFixed(5),
  );

  const groupItems = (items) => {
    const validItems = items.filter((item) => item.itemNo && item.qty);
    const grouped = {};

    validItems.forEach((item) => {
      const {
        itemNo,
        warehouse = "",
        warehouseId = "",
        weight,
        vm,
        qty,
      } = item;

      const key = `${itemNo}-${warehouse}-${warehouseId}-${weight ?? "NA"}-${vm ?? "NA"}`;

      if (!grouped[key]) {
        grouped[key] = {
          itemNo,
          warehouse,
          warehouseId,
          weight: weight ?? null,
          vm: vm ?? null,
          qty: Number(qty) || 0,
        };
      } else {
        grouped[key].qty += Number(qty) || 0;
      }
    });

    return Object.values(grouped);
  };

  const groupedItems = groupItems(itemsdetails);

  const getMaxColor = (totalValue, value) => {
    if (value === "No Limit") return "#31974D";
    return value >= totalValue ? "#31974D" : "#F93E3E";
  };

  const liStyles = {
    backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
    color: mode ? "#FFFFFF" : "#646B88",
    fontWeight: "600",
  };

  const dataListLiStyles = {
    backgroundColor: mode ? "#2C2E33" : "",
    color: mode ? "#FFFFFF" : "#646B88",
    fontWeight: "600",
  };

  const IPSLiStyles = {
    backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
  };

  return (
    <div
      className={`${styles.shipping_charges_modal} ${
        mode ? styles.shipping_charges_modal_dark : {}
      }`}
    >
      <div className={`${styles.scm_con}`}>
        <div className={styles.item_properties} style={{}}>
          <div className={styles.header_con}>
            <p className={styles.header}>Packaging Info</p>
          </div>
          <ul className={styles.data_list}>
            <li style={dataListLiStyles}>
              <div>Item</div>
              <div>Warehouse</div>
              <div>Quantity</div>
              <div>Volume(CBM)</div>
              <div>Weight(KG)</div>
            </li>
            <div className={styles.item_properties_scroll}>
              {groupedItems.map(
                ({ itemNo, warehouse, weight, vm, qty }, index) => (
                  <li style={IPSLiStyles} key={index}>
                    <div title={itemNo}>{itemNo}</div>
                    <div title={warehouse}>
                      {warehouse || generalInfo?.warehousename}
                    </div>
                    <div title={qty}>{qty}</div>
                    <div
                      title={`${qty} x ${vm || 0}`}
                    >{`${qty} x ${vm || 0}`}</div>
                    <div
                      title={`${qty} x ${weight || 0}`}
                    >{`${qty} x ${weight || 0}`}</div>
                  </li>
                ),
              )}
            </div>
            <div style={{ flex: "1" }}></div>
            <li style={liStyles}>
              <div>Total</div>
              <div></div>
              <div></div>
              <div>{totalCBM}</div>
              <div>{totalWeight}</div>
            </li>
          </ul>
        </div>

        {filter.selectedOption !== "no" && (
          <div className={`${styles.shipping_charges_mid}`}>
            <img
              src="/assets/updatedAssets/shippingCharge.png"
              alt="Shipping charges"
            />
            <p>
              Do you want the system to calculate shipping charges
              automatically?
            </p>

            <div>
              {!isShippingBlocked && (
                <div>
                  <Button
                    buttonText={"YES"}
                    buttonIcon={<TickIcon />}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#FFFFFF"}
                    buttonBorder={"none"}
                    buttonClick={handleNo}
                  />
                  <p className={styles.btn_text}>Press - Y</p>
                </div>
              )}

              {!isShippingBlocked && (
                <div>
                  <Button
                    buttonText={"NO"}
                    buttonIcon={<CrossIcon2 />}
                    buttonBgColor={"#F93E3E"}
                    buttonTextColor={"#FFFFFF"}
                    buttonBorder={"none"}
                    buttonClick={handleNo}
                  />
                  <p className={styles.btn_text}>Press - N</p>
                </div>
              )}

              <div>
                <Button
                  buttonText={"SKIP"}
                  buttonIcon={<SkipIcon />}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#FFFFFF"}
                  buttonBorder={"none"}
                  buttonClick={handleSkip}
                />
                <p className={styles.btn_text}>Press - S</p>
              </div>
            </div>
          </div>
        )}

        {filter.selectedOption === "no" && (
          <div className={styles.flex_col}>
            <div className={styles.flex}>
              <p className={styles.header} style={{ width: "100%" }}>
                Delivery Method
              </p>
              <span onClick={close} style={{ cursor: "pointer" }}>
                <CrossIcon color={mode ? "#FFF" : "#000"} />
              </span>
            </div>

            <InputTag
              value={courierName}
              readOnly={true}
              maxLength={100}
              padding={"8px"}
              fontSize={"12px"}
            />

            <div className={styles.delivery_method} onKeyDown={handleKeyDown}>
              {updatedPartners.map((p, index) => (
                <div
                  className={styles.delivery_method_element}
                  key={p.methodId}
                >
                  <div
                    className={`${styles.delivery_method_element_option} ${
                      focusedIndex === index ? styles.focused : ""
                    } ${mode ? styles.dark_Op : {}}`}
                    tabIndex={0}
                    ref={(el) => (elementsRef.current[index] = el)}
                    onClick={() => {
                      selectMethod(p);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        selectMethod(p);
                      }
                    }}
                  >
                    {p.methodName}
                  </div>
                  <div className={styles.flex} style={{ gap: "10px" }}>
                    <span>
                      Max Weight :
                      <span
                        style={{ color: getMaxColor(totalWeight, p.maxWeight) }}
                      >
                        {p.maxWeight}
                      </span>
                    </span>
                    <span>
                      Max Volume :
                      <span style={{ color: getMaxColor(totalCBM, p.maxVm) }}>
                        {p.maxVm}
                      </span>
                    </span>
                    <span>Max Limit : {p.maxLimit}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProSaleShippingChargesModal;
